import React from 'react';
import { motion } from 'framer-motion';
import {
  Target,
  Users,
  Award,
  Globe,
  CheckCircle,
  TrendingUp,
  Shield,
  Lightbulb,
  MapPin,
  Star,
  ArrowRight
} from 'lucide-react';

import india from  '../../Assests/india.jpg'
import nepal from  '../../Assests/nepal.png'
import { useNavigate } from 'react-router-dom';


const AboutUs = () => {

  const navigate =useNavigate()
  const stats = [
 { icon: Users, value: "100+", label: "Happy Clients" },
    { icon: Award, value: "200+", label: "Projects Completed" },
    { icon: Target, value: "8+", label: "Years Experience" },
    { icon: Star, value: "98%", label: "Success Rate" },
  ];

  const values = [
    {
      icon: Shield,
      title: "Quality",
      description: "We maintain the highest standards in all our consulting services, ensuring excellence in every project we undertake."
    },
    {
      icon: TrendingUp,
      title: "Promptness",
      description: "Time is valuable. We deliver results quickly and efficiently without compromising on quality."
    },
    {
      icon: Lightbulb,
      title: "Customized Services",
      description: "Every client is unique. We tailor our solutions to meet specific business needs and objectives."
    }
  ];

  const expertise = [
    "Integrated NGO Consultancy",
    "CSR Strategy & Implementation",
    "Research & Survey Design",
    "Human Resource Solutions",
    "Documentation & Translation Services",
    "Statutory & Financial Compliance",
    "Education & Training Module Development",
    "Social & Behaviour Change Communication (SBCC)",
    "Startup & Entrepreneurial Support",
    "Supply Chain & Field Implementation Support"
  ];

  const operatingStates = [
    "Bihar", "Uttar Pradesh", "West Bengal", "Jharkhand",
    "Uttarakhand", "Delhi", "Rajasthan","Maharashtra", "Nepal"
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-50 via-white to-primary-50 text-gray-900 pt-32 pb-20 overflow-hidden">
        {/* Abstract Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-32 h-32 border-2 border-primary-300 rounded-full"></div>
          <div className="absolute top-40 right-20 w-24 h-24 border-2 border-accent-300 transform rotate-45"></div>
          <div className="absolute bottom-32 left-1/4 w-20 h-20 border-2 border-primary-400 rounded-full"></div>
          <div className="absolute bottom-20 right-1/3 w-16 h-16 border-2 border-accent-400 transform rotate-12"></div>
          <div className="absolute top-1/2 left-1/2 w-12 h-12 border-2 border-primary-500 transform rotate-45"></div>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-16 left-1/4 w-3 h-3 bg-primary-400 rounded-full animate-bounce"></div>
        <div className="absolute top-32 right-1/4 w-2 h-2 bg-accent-400 rounded-full animate-bounce delay-1000"></div>
        <div className="absolute bottom-40 left-1/3 w-4 h-4 bg-primary-500 rounded-full animate-bounce delay-2000"></div>

        <div className="container-custom relative z-10">
          <div className="text-center max-w-5xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="space-y-8"
            >
              <div className="space-y-6">
                <div className="inline-flex items-center px-6 py-3 bg-primary-100 text-primary-700 rounded-full text-sm font-semibold border border-primary-200">
                  <Award className="h-4 w-4 mr-2" />
                  Trusted Since 2016
                </div>
                <h1 className="text-5xl lg:text-7xl font-bold text-gray-900 leading-tight">
                  About <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-accent-600">Lumbini</span>
                </h1>
                <p className="text-xl text-gray-600 leading-relaxed max-w-4xl mx-auto">
                  Excellence in consulting services with 8+ years of experience in transforming businesses and driving sustainable growth across multiple sectors. We are your trusted partner in achieving organizational success.
                </p>
              </div>

              {/* Stats Grid */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">
                {stats.map((stat, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
                    className="bg-white rounded-2xl p-6 border border-gray-200 hover:border-primary-300 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
                  >
                    <div className="flex justify-center mb-4">
                      <div className="w-12 h-12 bg-gradient-to-r from-primary-600 to-accent-600 rounded-xl flex items-center justify-center">
                        <stat.icon className="h-6 w-6 text-white" />
                      </div>
                    </div>
                    <div className="text-3xl font-bold text-gray-900 text-center mb-1">{stat.value}</div>
                    <div className="text-sm text-gray-600 text-center font-medium">{stat.label}</div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-20 bg-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-accent-600">Mission</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              To serve our clients by providing the highest quality Proposal Development, NGO Consultancy, HR Consultancy, Financial and Statutory Compliance Consultancy, Research and Documentation Services, Professional Management and Consulting services that address their needs.
                          </p>
          </motion.div>

          <div className="grid lg:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-2xl p-8 text-center group hover:transform hover:-translate-y-2 transition-all duration-300 border border-gray-200 hover:border-primary-300 hover:shadow-xl"
              >
                <div className="w-16 h-16 bg-gradient-to-r from-primary-600 to-accent-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <value.icon className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-primary-600 transition-colors">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-accent-600">Expertise</span>
              </h2>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                Solutions Elevate your impact with Lumbini’s integrated consulting expertise. From grassroots NGOs to dynamic startups, and public domain we offer tailored support across sectors—driving innovation, operational excellence, and measurable outcomes.

</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {expertise.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    className="flex items-center space-x-3 p-4 rounded-xl hover:bg-primary-50 transition-colors border border-gray-100 hover:border-primary-200"
                  >
                    <CheckCircle className="h-5 w-5 text-primary-600 flex-shrink-0" />
                    <span className="text-gray-700 font-medium">{item}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Areas of Operation</h3>
                <p className="text-gray-600 mb-6">
                  We are currently operational in Nepal and multiple states across India, providing our expertise to clients nationwide.
                </p>

                <div className="grid grid-cols-2 gap-3 mb-8">
                  {operatingStates.map((state, index) => (
                    <div key={index} className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-50 transition-colors">
                      <MapPin className="h-4 w-4 text-primary-600" />
                      <span className="text-gray-700 font-medium">{state}</span>
                    </div>
                  ))}
                </div>

                <div className="flex items-center justify-center space-x-8">
                  <div className="text-center">
                    <img src={india} alt="India" className="h-16 w-auto mx-auto mb-2" />
                    <span className="text-sm text-gray-600">India</span>
                  </div>
                  <div className="text-center">
                    <img src={nepal} alt="Nepal" className="h-16 w-auto mx-auto mb-2" />
                    <span className="text-sm text-gray-600">Nepal</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-gradient-to-br from-primary-50 to-accent-50">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-accent-600">Team</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              The organization is headed by a visionary and experienced leader. Our team consists of experts from various domains with multi-year practical experience in their respective fields.
            </p>
          </motion.div>


        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-primary-600 to-accent-600">
        <div className="container-custom text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-white"
          >
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              Ready to Transform Your Business?
            </h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto text-white/90">
              Partner with Lumbini Consultancy and experience the difference that 8+ years of expertise can make to your organization.
            </p>
            <motion.button
              className="bg-white text-primary-600 hover:bg-gray-100 font-semibold py-4 px-8 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl group"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={()=>navigate('/contactus')}
            >
              <span className="flex items-center">
                Get Started Today
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </span>
            </motion.button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
